import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { SharedValue, useAnimatedStyle } from 'react-native-reanimated';

import { Image } from '@sg/garnish';

import { Hexagon, Logo } from '../../assets';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPromptHexagon = memo((props: Props) => {
  const { opacitySV, scaleSV } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerAnimatedStyles = useAnimatedStyle(() => ({
    transform: [{ scale: scaleSV.value }],
  }));

  const overlayAnimatedStyles = useAnimatedStyle(() => ({
    opacity: opacitySV.value,
  }));

  const overlayStyles = [styles.overlay, overlayAnimatedStyles];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Animated.View style={containerAnimatedStyles}>
      <View>
        <Image source={Hexagon} style={styles.image} contentFit="contain" accessible={false} />
      </View>

      <Animated.View style={overlayStyles}>
        <Image source={Logo} style={styles.image} contentFit="contain" accessible={false} />
      </Animated.View>
    </Animated.View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
  },
  image: {
    width: 1000,
    height: 1000,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  opacitySV: SharedValue<number>;
  scaleSV: SharedValue<number>;
};
